import { Time } from 'common/utils';

import { intl } from 'i18n/Translations';

export const getHereRouteTime = (sections: any[]): Time => {
  const timestamp = sections.reduce((acc: number, { travelSummary: { baseDuration } }: any) => (baseDuration ? acc + baseDuration : acc), 0);
  const hours = Math.floor(timestamp / 60 / 60);
  const minutes = Math.floor(timestamp / 60) % 60;
  return `${hours} ${intl.formatMessage({ id: 'hours' })} ${minutes} ${intl.formatMessage({ id: 'min' })}`;
};
